import { Outlet } from 'react-router-dom';

import { useOktaAuth } from '@okta/okta-react';
import PropTypes from 'prop-types';

const SecureRoute = ({ onAuthRequired, children }) => {
  const { oktaAuth, authState } = useOktaAuth();

  if (!authState.isAuthenticated) {
    if (onAuthRequired) {
      onAuthRequired(oktaAuth);
    } else {
      oktaAuth.signInWithRedirect();
    }

    return null;
  }

  return children || <Outlet />;
};

SecureRoute.propTypes = {
  onAuthRequired: PropTypes.func.isRequired,
  children: PropTypes.node
};

SecureRoute.defaultProps = {
  children: null
};

export default SecureRoute;
